import React from "react";
import "./ApprovalButton.css";

const ApprovalButton = ({ status, onApprove, onReject }) => {
  if (status === 'approved') {
    return (
      <button className="approval-btn btn-approved" disabled>
        Approved
      </button>
    );
  }

  if (status === 'rejected') {
    return (
      <button className="approval-btn btn-rejected" disabled>
        Rejected
      </button>
    );
  }

  // Default: pending
  return (
    <div className="btn-group">
      <button className="approval-btn btn-approve" onClick={onApprove}>
        Approve
      </button>
      <button className="btn-reject-x" onClick={onReject} title="Reject">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M2 2L12 12M12 2L2 12" stroke="#E24B4A" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  );
};

export default ApprovalButton;